import { Controller } from "@hotwired/stimulus"

// Shows/hides sections based on a selected radio value. Each item target
// declares data-reveal-when="value1 value2".
export default class extends Controller {
  static targets = ["item", "radio"]

  connect() {
    this.apply(this.currentValue())
  }

  change(event) {
    this.apply(event.target.value)
  }

  currentValue() {
    const checked = this.radioTargets.find((r) => r.checked)
    return checked ? checked.value : null
  }

  apply(value) {
    this.itemTargets.forEach((el) => {
      const show = (el.dataset.revealWhen || "").split(" ").includes(value)
      el.classList.toggle("hidden", !show)
    })
  }
}
